export const APPEARING = "Appearing";
export const FROM = "from";
export const TO = "to";
export const RESULTS = "results";
export const ZERO = 0;
